import React from "react";
import { connect } from "react-redux";
import ClaimsHeader from "./Components/ClaimsHeader/ClaimsHeader";
import ClaimsWrapper from "./Components/ClaimsWrapper/ClaimsWrapper";
//import *  as actions from "../Redux/actions.js"
import * as actions from "./Redux/actions.js"
import { ClaimStatusEnum } from "./enum";
import { getPartnerGuid } from "../../../lib/access.es6";
import find from 'lodash/find';


// Emple has no separate Open / Payable / Closed claims pages (those read the simple claims service), so its
// dashboard also shows what has been paid, rejected or cancelled.
const EMPLE_EXTRA_TABS = [
  { label: 'Approved Paid', statuses: ['Approved_Paid'] },
  { label: 'Rejected', statuses: ['Rejected', 'Rejected_Pending'] },
  { label: 'Cancelled', statuses: ['Cancelled'] }
]

class ClaimDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentWillMount() {
    const payload = {
      "partner": getPartnerGuid(),
      "statuses": ClaimStatusEnum.docs_pending
    }
    this.props.dispatch(actions.getClaimsDcpRequest(payload))
  }

  getClaims(payload) {
    this.props.dispatch(actions.getClaimsDcpRequest(payload
    ))
  }

  handleBulkApproval(payload) {
    this.props.dispatch(actions.bulkApproveRequest(payload))
  }

  filterHospitalClaim(claims) {
    return claims.filter(claim => claim.preauthorization_number !== null)
  }

  isDeathClaim(claim) {
    const hasDeathBenefit = !!find(claim.benefits, { type: "DEATH BENEFIT" })
    const hasNoLou = claim.preauthorization_number === null;

    return hasDeathBenefit && hasNoLou
  }

  isReimbusermentClaim(claim) {
    const hasDeathBenefit = !!find(claim.benefits, { type: "DEATH BENEFIT" })
    const hasNoLou = claim.preauthorization_number === null;

    return !hasDeathBenefit && hasNoLou
  }


  filterDeathClaim(claims) {
    return claims.filter(claim => this.isDeathClaim(claim))
  }
  render() {
    const claimEx = this.props.bulkApprovalData.claims_dcp || []
    const claims = this.filterHospitalClaim(claimEx)
    console.log("death claims", claims)
    return (
      <>
        <ClaimsHeader
          title="Claims Dashboard"
        />

        <ClaimsWrapper
          claimsData={this.props.claimDashboardData.claims_dcp }
          type="Death"
          extraTabs={getPartnerGuid() === 'MMI_Ghana' ? EMPLE_EXTRA_TABS : undefined}
          hasAlerts={true}
          hasBulkApprove={true}
          getClaims={this.getClaims.bind(this)}
          loading={this.props.bulkApprovalData.get_claims_dcp_loader}
          handleBulkApproval={this.handleBulkApproval.bind(this)}

          showBulkApproveProgressAlert={this.props.bulkApprovalData.bulkApprovalClaimLoader}
          showBulkApproveSuccessAlert={this.props.bulkApprovalData.bulkApprovalClaimSuccess}
          showBulkApproveErrorAlert={!!this.props.bulkApprovalData.bulkApprovalClaimError}
          bulkApproveError={this.props.bulkApprovalData.bulkApprovalClaimError}

          resetBulkApproveSuccessAlert={() => { this.props.dispatch(actions.resetbulkApprovalSuccess()) }}
          resetBulkApproveErrorAlert={() => { this.props.dispatch(actions.resetbulkApprovalFailure()) }}
        />
      </>
    )

  }

}
export default connect((state) => ({
  customerData: state.currentCustomer,
  claimDashboardData: state.claimDashboardData,
  bulkApprovalData: state.bulkApprovalData,
  globalData: state.global,
}))(ClaimDashboard);